// extracted by mini-css-extract-plugin
export default {"headingWrapper":"HeadingComponent_headingWrapper__aLCAx","headingImage":"HeadingComponent_headingImage__UeNOG","arrowBack":"HeadingComponent_arrowBack__bE8Po"};